import {useTimePicker} from '@/components/atoms/TimePicker/useTimePicker'
import {TimePicker as PepsicoDsTimePicker} from 'pepsico-ds'
import {useMemo} from 'react'
import {isInvalidTime} from '@/helpers/dateUtils'
import './_timePicker.scss'

export default function TimePicker({value, updateValue, uiSchema}) {
  const {label, className, validationRules = []} = uiSchema

  const {validateStartandEndTime, cleanValue} = useTimePicker(validationRules)

  const helperText = useMemo(() => {
    if (isInvalidTime(value)) return 'Invalid time'
    return validateStartandEndTime(value) || ''
  }, [value, validateStartandEndTime])

  const error = helperText !== ''

  return (
    <div className="time-picker-wrapper">
      <PepsicoDsTimePicker
        id={error ? 'time-picker-error' : ''}
        className={className}
        label={label}
        setSelected={time => {
          const val = cleanValue(time?.value)
          updateValue(val)
        }}
        selected={{
          timeZone: '',
          type: undefined,
          value: value,
        }}
        size="medium"
        style={{}}
        showTimezones={false}
        feedbackType={error ? 'error' : 'info'}
        helperText={error ? helperText : ''}
      />
    </div>
  )
}
